import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { SuraCommonsUiModule } from "@surainvestments/sura-common-ui";
import { ResizableModule } from "angular-resizable-element";
import { MarkdownModule } from 'ngx-markdown';
import { NavbarAccountButtonModule } from '../../modules/layout/navbar-account-button/navbar-account-button.module';
import { ChatBotAsesorV2MensajePipe } from '../../pipes/chat-bot-asesor-v2-mensaje.pipe';
import { AssetService } from '../../services/asset/asset.service';
import { ChatBotLogService } from '../../services/chat-bot/chat-bot-log.service';
import { LogService } from '../../services/logs/logs.service';
import { SharedModule } from '../../shared.module';
import { AlertModule } from '../alert/alert.module';
import { ChatBotAsesorV2AyudaComponent } from './chat-bot-asesor-v2-ayuda/chat-bot-asesor-v2-ayuda.component';
import { ChatBotAsesorV2BorrarChatComponent } from './chat-bot-asesor-v2-borrar-chat/chat-bot-asesor-v2-borrar-chat.component';
import { ChatBotAsesorV2BreadcrumbsComponent } from './chat-bot-asesor-v2-breadcrumbs/chat-bot-asesor-v2-breadcrumbs.component';
import { ChatBotAsesorV2BtnComponent } from './chat-bot-asesor-v2-btn/chat-bot-asesor-v2-btn.component';
import { ChatBotAsesorV2ChatHistorialComponent } from './chat-bot-asesor-v2-chat/chat-bot-asesor-v2-chat-historial/chat-bot-asesor-v2-chat-historial.component';
import { ChatBotAsesorV2ChatComponent } from './chat-bot-asesor-v2-chat/chat-bot-asesor-v2-chat.component';
import { ChatBotAsesorV2DashboardFiltrosComponent } from './chat-bot-asesor-v2-dashboard/chat-bot-asesor-v2-dashboard-filtros/chat-bot-asesor-v2-dashboard-filtros.component';
import { ChatBotAsesorV2DashboardComponent } from './chat-bot-asesor-v2-dashboard/chat-bot-asesor-v2-dashboard.component';
import { ChatBotAsesorV2DialogFeedbackComponent } from './chat-bot-asesor-v2-dialog-feedback/chat-bot-asesor-v2-dialog-feedback.component';
import { ChatBotAsesorV2EncuestaComponent } from './chat-bot-asesor-v2-encuesta/chat-bot-asesor-v2-encuesta.component';
import { ChatBotAsesorV2HeaderComponent } from './chat-bot-asesor-v2-header/chat-bot-asesor-v2-header.component';
import { ChatBotAsesorV2MenuComponent } from './chat-bot-asesor-v2-menu/chat-bot-asesor-v2-menu.component';
import { ChatBotAsesorV2SidenavComponent } from './chat-bot-asesor-v2-sidenav/chat-bot-asesor-v2-sidenav.component';
import { ChatBotAsesorV2TerminosComponent } from './chat-bot-asesor-v2-terminos/chat-bot-asesor-v2-terminos.component';
import { ChatBotAsesorV2UploadComponent } from './chat-bot-asesor-v2-upload/chat-bot-asesor-v2-upload.component';
import { ChatBotAsesorV2Component } from './chat-bot-asesor-v2.component';

@NgModule({
    declarations: [
        ChatBotAsesorV2Component,
        ChatBotAsesorV2BtnComponent,
        ChatBotAsesorV2MenuComponent,
        ChatBotAsesorV2ChatComponent,
        ChatBotAsesorV2DashboardComponent,
        ChatBotAsesorV2EncuestaComponent,
        ChatBotAsesorV2TerminosComponent,
        ChatBotAsesorV2AyudaComponent,
        ChatBotAsesorV2BreadcrumbsComponent,
        ChatBotAsesorV2ChatHistorialComponent,
        ChatBotAsesorV2UploadComponent,
        ChatBotAsesorV2HeaderComponent,
        ChatBotAsesorV2SidenavComponent,
        ChatBotAsesorV2BorrarChatComponent,
        ChatBotAsesorV2DashboardFiltrosComponent,
        ChatBotAsesorV2DialogFeedbackComponent,
        ChatBotAsesorV2MensajePipe
    ],
    exports: [
        ChatBotAsesorV2BtnComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        SuraCommonsUiModule,
        ResizableModule,
        MatDialogModule,
        MatButtonModule,
        NavbarAccountButtonModule,
        SharedModule,
        RouterModule,
        ReactiveFormsModule,
        MarkdownModule.forChild(),
        ClipboardModule,
        MatFormFieldModule,
        MatSelectModule,
        MatSnackBarModule,
        MatTableModule,
        AlertModule,
        MatSidenavModule,
        MatSortModule,
        MatInputModule,
        MatTooltipModule
    ],
    providers: [
        ChatBotLogService,
        LogService,
        AssetService,
    ],
    entryComponents: [
        ChatBotAsesorV2Component,
        ChatBotAsesorV2TerminosComponent,
        ChatBotAsesorV2EncuestaComponent,
        ChatBotAsesorV2UploadComponent,
        ChatBotAsesorV2BorrarChatComponent,
        ChatBotAsesorV2DialogFeedbackComponent,
    ]
})
export class ChatBotAsesorV2Module { }
